var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"loading-overlay",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":"48","indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }